function getDefaultNewFilter() {
    return {
        filterId: '',
        name: '',
        matchAllConditions: true,
        conditions: [],
    };
}
export default getDefaultNewFilter;
